import React, { useState, useEffect } from 'react'
import { ApolloProvider } from '@apollo/client'
import { ThemeProvider, CssBaseline, Box } from '@mui/material'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/700.css'
import { apolloClient } from './apollo'
import { createAppTheme, EColorScheme } from './theme'
import { useQueryParams } from './hooks'
import { StatusPage } from './components'

const AppContent: React.FC = () => {
  const { colorScheme } = useQueryParams()
  const [isPrintMode, setIsPrintMode] = useState(false)

  // Listen for print mode changes (for PDF export in light mode)
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-print-mode') {
          const printMode = document.documentElement.getAttribute('data-print-mode') === 'true'
          setIsPrintMode(printMode)
        }
      })
    })

    observer.observe(document.documentElement, { attributes: true })
    return () => observer.disconnect()
  }, [])

  // Force light mode when printing
  const effectiveColorScheme = isPrintMode ? EColorScheme.LIGHT : colorScheme
  const theme = createAppTheme(effectiveColorScheme)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: 'background.default',
        }}
      >
        <StatusPage />
      </Box>
    </ThemeProvider>
  )
}

export const App: React.FC = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <AppContent />
    </ApolloProvider>
  )
}
